var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"red":""}},[_c('div',{staticClass:"l-login"},[_c('div',{staticClass:"l-login-form"},[_c('router-view')],1),_c('div',{staticClass:"l-login-info d-none d-lg-block d-none d-md-block"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }